import { useGoogleAd } from '../hook/useGoogleAd';

interface IProps {
  id: string;
  dataDfp: string;
  dataSizes: [number, number][];
}

const GoogleAd = ({ id, dataDfp, dataSizes }: IProps) => {
  useGoogleAd(id);

  const maxWidth = dataSizes.reduce((max, size) => Math.max(max, size[0]), 0);
  const maxHeight = dataSizes.reduce((max, size) => Math.max(max, size[1]), 0);

  return (
    <div
      className="adslot w-full h-full"
      id={id}
      style={{
        maxWidth: `${maxWidth}px`,
        maxHeight: `${maxHeight}px`,
      }}
      data-dfp={dataDfp}
      data-sizes={JSON.stringify(dataSizes)}
    />
  );
};

export default GoogleAd;
